module.exports = "/images/everestPath5.png?454cf6142ea93fdabee91607649a6208";